import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const PriceBreakdownAddOns = ({
  addOnsContracts,
  profile,
  currency
}) => {
  return (
    <div className="add-ons" data-testing-id="price-breakdown-addons">
      <div className="text-base margin-sm-bottom text-gray-900">
        <b>
          <FormattedMessage
            id="inbox.fee_calc_price_breakdown.addons"
            defaultMessage="Add-ons"
          />
        </b>
      </div>
      {addOnsContracts.map((addOnContract, i) => {
        if (!addOnContract.units) {
          return null;
        }

        return (
          <div
            key={`add-on-${i}`}
            className={classnames('row', { 'margin-sm-top': i > 0 })}
            data-testing-id="add-on-row"
          >
            <div className="col-xs-6 flex">
              <span className="truncate">{addOnContract.meta?.label}</span>
              <span className="text-gray-600 margin-sm-left">
                <span className="margin-sm-right">x</span>
                <span className="margin-sm-right">{addOnContract.units}</span>
                {addOnContract.meta?.unit_cost_basis === 'per_hour' && (
                  <span>
                    <FormattedMessage
                      id="inbox.fee_calc_price_breakdown.hours_short"
                      defaultMessage="hrs"
                    />
                  </span>
                )}
              </span>
            </div>
            <div
              className="col-xs-6 text-xs-right"
              data-testing-id="price-breakdown-addons-amount"
            >
              <FormattedNumber
                value={addOnContract.primary_amount[profile.SSOid]}
                currency={currency}
                style="currency"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

PriceBreakdownAddOns.propTypes = {
  addOnsContracts: PropTypes.arrayOf(PropTypes.object).isRequired,
  profile: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired
};
